import { Form } from './Form';
import { Range } from './Range';
import { Terms } from './Terms';
import { Amount } from './Amount';
import { useContext } from 'react';
import { Field } from '@zopauk/web-ui';
import { Band } from '@/components/Modules/Band/Band';
import type { Document } from 'datocms-structured-text-utils';
import type { CalculatorFragment } from '@/utils/dato/generated';
import { RepresentativeApr } from '@/components/RepresentativeApr';
import { CalculatorContext } from '@/components/Calculator/Context';

const Calculator = ({ representativeExample, button, label, id }: CalculatorFragment) => {
  const { channel } = useContext(CalculatorContext);

  return (
    <Band className="!bg-white relative z-10 !px-0 [&_.band-content]:!px-0 bg--color-background">
      <div className="mx-auto max-w-[612px] bg-white relative z-10">
        <div
          className="calculator-module bg-white px-6 py-8 shadow-[0_1px_2px_1px_var(--color-base-200)] rounded-lg relative z-10 md:p-8 [&_button[type='submit']]:w-full text-right lg:[&_button[type='submit']]:w-3/5"
          data-automation={`ZA.calculator-${id}`}
        >
          {label ? (
            <Field.Label
              className="mb-6 lg:mb-5 font-semibold text-lg text-center block"
              data-automation="ZA.calculator.amount-label"
              htmlFor={`loan-amount-${id}`}
            >
              {label}
            </Field.Label>
          ) : null}

          <Amount id={id} />

          <Range />

          <Terms id={id} />

          <Form button={button} />
          {representativeExample ? (
            <RepresentativeApr copy={representativeExample.value as Document} channel={channel} />
          ) : null}
        </div>
      </div>
    </Band>
  );
};

export default Calculator;
